<template>
	<div class="table" v-if="purchaseList.length > 0 && !isMobile">
		<div v-for="item in purchaseList" :key="item.seq" class="table_item">
			<div class="list_item">
				<div class="list_num">{{ item._no }}</div>
				<div class="item_box">
					<div class="item">
						<p>{{ $t('rtr_activity-c2c.purchased_asset') }}</p>
						<div class="asset_box mb_10">
							<span :class="[item.source_asset_code, 'small']"></span>
							<p class="code mr_4 mb_0">{{ item.source_asset_code }}</p>
							<p class="name">{{ item.source_asset_title }}</p>
						</div>
						<p class="fs_12 fc_gray2">
							{{ $dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss') }}
						</p>
					</div>
					<div class="item">
						<p>{{ $t('rtr_activity-c2c.purchase_quantity') }}</p>
						<p>{{ item.source_amount }}</p>
					</div>
					<div class="item">
						<p>{{ $t('rtr_activity-c2c.purchase_price') }}</p>
						<p>
							1 <span class="fs_12">{{ item.source_asset_code }} = </span>
						</p>
						<p>
							{{ item.price }}
							<span class="fs_12">{{ item.target_asset_code }}</span>
						</p>
					</div>
					<div class="item">
						<p>{{ $t('rtr_activity-c2c.payment_asset') }}</p>
						<div class="asset_box">
							<span :class="[item.target_asset_code, 'small']"></span>
							<p class="code mr_4 mb_0">{{ item.target_asset_code }}</p>
							<p class="name">{{ item.target_asset_title }}</p>
						</div>
					</div>
					<div class="item">
						<p>{{ $t('rtr_activity-c2c.total_fee') }}</p>
						<p>{{ item.fee_amount }}</p>
					</div>
					<div class="item">
						<p>{{ $t('rtr_activity-c2c.account_number') }}</p>
						<p>{{ item.deal_account_number }}</p>
					</div>
				</div>
				<div class="item status_area">
					<div :class="'status ' + item.status">
						<span class="icon"></span>
						<span>{{ $t('c2c.' + item.status) }}</span>
					</div>
				</div>
			</div>
			<!-- 테이블 컨텐츠2 -->
			<div class="list_item2">
				<div class="btn_area">
					<button
						class="button_primary ml_10"
						@click="$emit('showDetail', item)"
					>
						{{ $t('button.detail') }}
					</button>
					<template
						v-if="
							item.escrow_type === 'DEALER' || item.escrow_type === 'DISABLE'
						"
					>
						<button
							v-if="item.status === 'PENDING'"
							class="button_bg_blue ml_10"
							@click="privateApplicationHandler(item.seq, 'SET_PAYED')"
						>
							{{ $t('button.payment') }}
						</button>
						<button
							class="button_bg_red ml_10"
							v-if="item.status === 'PENDING' || item.status === 'PAYED'"
							@click="privateApplicationHandler(item.seq, 'SET_CANCELED')"
						>
							{{ $t('button.cancel') }}
						</button>
					</template>
					<template v-if="item.escrow_type === 'APPLICANT'">
						<button
							v-if="item.status === 'PENDING' || item.status === 'PAYED'"
							class="green ml_10"
							@click="privateApplicationHandler(item.seq, 'SET_CONFIRMED')"
						>
							{{ $t('button.decide') }}
						</button>
						<button
							class="button_bg_red ml_10"
							v-if="item.status === 'PENDING'"
							@click="privateApplicationHandler(item.seq, 'SET_CANCELED')"
						>
							{{ $t('button.cancel') }}
						</button>
					</template>
				</div>
			</div>
		</div>
		<pagination
			:totalCount="pageNavigation.total_count"
			:totalPage="pageNavigation.total_page"
			:curPage="pageNavigation.cur_page"
			:point="pageNavigation.point"
			:firstPage="pageNavigation.first_page"
			:lastPage="pageNavigation.last_page"
			@change="pageChangeHandler"
		></pagination>
	</div>
	<div class="table_mobile" v-if="purchaseList.length > 0 && isMobile">
		<div v-for="item in purchaseList" :key="item.seq" class="table_item_mobile">
			<div class="list_item_mobile">
				<div class="cont">
					<div class="list_title_box">
						<div class="num">{{ item._no }}</div>
						<div class="date">
							{{ $dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss') }}
						</div>
					</div>
					<div class="list_info_box">
						<div class="item">
							<div class="status_area">
								<div :class="'status ' + item.status">
									<span class="icon"></span>
									<span>{{ $t('c2c.' + item.status) }}</span>
								</div>
							</div>
						</div>
						<div class="item">
							<div>
								<p>{{ $t('rtr_activity-c2c.purchased_asset') }}</p>
								<div class="asset_box">
									<span :class="[item.source_asset_code, 'small']"></span>
									<p class="code mr_4 mb_0">{{ item.source_asset_code }}</p>
									<p class="name">{{ item.source_asset_title }}</p>
								</div>
							</div>
							<div>
								<p>{{ $t('rtr_activity-c2c.payment_asset') }}</p>
								<div class="asset_box">
									<span :class="[item.target_asset_code, 'small']"></span>
									<p class="code mr_4 mb_0">{{ item.target_asset_code }}</p>
									<p class="name">{{ item.target_asset_title }}</p>
								</div>
							</div>
						</div>
						<div class="item">
							<div>
								<p>{{ $t('rtr_activity-c2c.purchase_quantity') }}</p>
								<p>{{ item.source_amount }}</p>
							</div>
						</div>
						<div class="item">
							<div>
								<p>{{ $t('rtr_activity-c2c.purchase_price') }}</p>
								<div class="d_flex align_items_center">
									<p>
										1 <span class="fs_12">{{ item.source_asset_code }} = </span>
									</p>
									<p>
										{{ item.price }}
										<span class="fs_12">{{ item.target_asset_code }}</span>
									</p>
								</div>
							</div>
						</div>
					</div>
					<div class="button_area">
						<button class="button_bg_blue" @click="$emit('showDetail', item)">
							{{ $t('button.detail') }}
						</button>
					</div>
					<div class="button_more_area">
						<div class="line"></div>
						<button @click="toggleMoreContent(item.seq)">
							<img
								:src="isItemOpen(item.seq) ? moreClose : more"
								alt="more"
								style="width: 24px; height: 24px"
							/>
						</button>
					</div>
				</div>
				<div class="more_cont" v-if="isItemOpen(item.seq)">
					<div class="list_info_box">
						<div class="item">
							<div>
								<p>{{ $t('rtr_activity-c2c.total_fee') }}</p>
								<p>{{ item.fee_amount }}</p>
							</div>
						</div>
						<div class="item">
							<div>
								<p>{{ $t('rtr_activity-c2c.account_number') }}</p>
								<p>{{ item.deal_account_number }}</p>
							</div>
						</div>
					</div>
					<div class="button_area">
						<template
							v-if="
								item.escrow_type === 'DEALER' || item.escrow_type === 'DISABLE'
							"
						>
							<button
								v-if="item.status === 'PENDING'"
								class="button_bg_blue"
								@click="privateApplicationHandler(item.seq, 'SET_PAYED')"
							>
								{{ $t('button.payment') }}
							</button>
							<button
								class="button_primary"
								v-if="item.status === 'PENDING' || item.status === 'PAYED'"
								@click="privateApplicationHandler(item.seq, 'SET_CANCELED')"
							>
								{{ $t('button.cancel') }}
							</button>
						</template>
						<template v-if="item.escrow_type === 'APPLICANT'">
							<button
								v-if="item.status === 'PENDING' || item.status === 'PAYED'"
								class="green"
								@click="privateApplicationHandler(item.seq, 'SET_CONFIRMED')"
							>
								{{ $t('button.decide') }}
							</button>
							<button
								class="button_primary"
								v-if="item.status === 'PENDING'"
								@click="privateApplicationHandler(item.seq, 'SET_CANCELED')"
							>
								{{ $t('button.cancel') }}
							</button>
						</template>
					</div>
				</div>
			</div>
		</div>
		<pagination
			:totalCount="pageNavigation.total_count"
			:totalPage="pageNavigation.total_page"
			:curPage="pageNavigation.cur_page"
			:point="pageNavigation.point"
			:firstPage="pageNavigation.first_page"
			:lastPage="pageNavigation.last_page"
			@change="pageChangeHandler"
		></pagination>
	</div>
	<div v-if="purchaseList.length === 0">
		<div class="list_none" v-if="!loading">
			<span class="ERRORGRAY"></span>
			<p>{{ $t('rtr_activity-c2c.empty') }}</p>
		</div>
	</div>
	<ModalMessage v-if="messageModal" @closeModal="messageModal = false">
		<div :class="'status_icon ' + modalIcon"></div>
		<p class="status_text">{{ modalStatusMessage }}</p>
		<div v-if="messageModalMode === 'success'" class="button_area">
			<button class="button_bg_blue" @click="messageModal = false">
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
		<div v-if="messageModalMode === 'information'" class="button_area">
			<button class="button_primary" @click="messageModal = false">
				{{ $t('button.cancel') }}
			</button>
			<button class="button_bg_blue" @click="confirmHandler">
				{{ $t('button.confirm') }}
			</button>
		</div>
	</ModalMessage>
</template>
<script>
import Pagination from '@/components/Pagination';
import ModalMessage from '@/components/Layout/ModalMessage';
import {
	cancelPrivateApplication,
	confirmPrivateApplication,
	fetchPrivateApplications,
	payPrivateApplication,
} from '@/api/application';
import { commonError } from '@/common/dialog';
import more from '@/assets/images/v2/icon/more.svg';
import moreClose from '@/assets/images/v2/icon/more-close.svg';

export default {
	name: 'Purchase',
	emits: ['showDetail'],
	props: ['startDate', 'endDate'],
	components: {
		Pagination,
		ModalMessage,
	},
	data() {
		return {
			mobile: window.innerWidth <= 768,
			purchaseList: [],
			pageNavigation: {},
			curPage: 1,
			listCount: 10,
			messageModal: false,
			modalIcon: '',
			modalStatusMessage: '',
			messageModalMode: '',
			patchSeq: null,
			patchType: '',
			loading: false,
			openedItems: [],
			more,
			moreClose,
		};
	},
	watch: {
		startDate() {
			this.loadPurchaseList();
		},
		endDate() {
			this.loadPurchaseList();
		},
	},
	mounted() {
		this.checkMobile();
		window.addEventListener('resize', this.checkMobile);
		this.init();
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile);
	},
	methods: {
		checkMobile() {
			this.mobile = window.innerWidth <= 768;
		},
		toggleMoreContent(itemSeq) {
			const index = this.openedItems.indexOf(itemSeq);
			if (index > -1) {
				this.openedItems.splice(index, 1);
			} else {
				this.openedItems.push(itemSeq);
			}
		},
		isItemOpen(itemSeq) {
			return this.openedItems.includes(itemSeq);
		},
		init() {
			this.loadPurchaseList();
		},
		async loadPurchaseList() {
			this.loading = true;
			const params = {
				regdate_start: this.$dayjs(new Date(this.startDate))
					.startOf('day')
					.valueOf(),
				regdate_end: this.$dayjs(this.endDate).endOf('day').valueOf(),
				page: this.curPage,
				list_count: this.listCount,
			};
			const { data, page_navigation } = await fetchPrivateApplications(
				params,
			).catch(commonError);
			this.loading = false;
			this.purchaseList = data;
			this.pageNavigation = page_navigation;
		},
		pageChangeHandler(pageNo) {
			this.curPage = pageNo;
			this.loadPurchaseList();
		},
		privateApplicationHandler(seq, type) {
			this.patchSeq = seq;
			this.patchType = type;
			let message = '';
			switch (type) {
				case 'SET_CANCELED':
					message = this.$t('modal.message.set_cancel');
					break;
				case 'SET_PAYED':
					message = this.$t('modal.message.set_pay');
					break;
				case 'SET_CONFIRMED':
					message = this.$t('modal.message.set_confirm');
					break;
			}
			this.modalIcon = 'information';
			this.modalStatusMessage = message;
			this.messageModalMode = 'information';
			this.messageModal = true;
		},
		confirmHandler() {
			this.messageModal = false;
			switch (this.patchType) {
				case 'SET_CANCELED':
					this.cancelPrivateApplication();
					break;
				case 'SET_PAYED':
					this.payPrivateApplication();
					break;
				case 'SET_CONFIRMED':
					this.confirmPrivateApplication();
					break;
			}
		},
		async confirmPrivateApplication() {
			await confirmPrivateApplication(this.patchSeq)
				.then(() => {
					this.modalIcon = 'success';
					this.modalStatusMessage = this.$t('modal.message.success_confirm');
					this.messageModalMode = 'success';
					this.messageModal = true;
					this.loadPurchaseList();
				})
				.catch(commonError);
		},
		async cancelPrivateApplication() {
			await cancelPrivateApplication(this.patchSeq)
				.then(() => {
					this.modalIcon = 'success';
					this.modalStatusMessage = this.$t('modal.message.success_cancel');
					this.messageModalMode = 'success';
					this.messageModal = true;
					this.loadPurchaseList();
				})
				.catch(commonError);
		},
		async payPrivateApplication() {
			await payPrivateApplication(this.patchSeq)
				.then(() => {
					this.modalIcon = 'success';
					this.modalStatusMessage = this.$t('modal.message.success_payment');
					this.messageModalMode = 'success';
					this.messageModal = true;
					this.loadPurchaseList();
				})
				.catch(commonError);
		},
	},
	computed: {
		isMobile() {
			return this.mobile;
		},
	},
};
</script>
<style scoped></style>
